export default {"src":"/_next/static/media/tertiary-fire.017bcc67.svg","height":9,"width":7,"blurWidth":0,"blurHeight":0};